import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import swal from 'sweetalert2';
import Navbar from '../components/navbar';
import Dashboard from '../components/dashboard';
import MIS from '../components/mis';

const Master = (props) => {

    const [type,                setType]                = useState('All');
    const [status,              setStatus]              = useState('All');
    
    return (  
        <>                    
            <Navbar 
                type={type} 
                setType={setType} 
                status={status} 
                setStatus={setStatus} 
            />
            <Switch>
                <Route path="/dashboard">
                    <Dashboard 
                        type={type} 
                        setType={setType} 
                        status={status} 
                        setStatus={setStatus} 
                    />
                </Route>
                <Route path="/mis">
                    <MIS />
                </Route>
                <Redirect to="/dashboard" />
            </Switch>
        </>
    )
}

export default withRouter(Master);